import React from 'react';
import PropTypes from 'prop-types';

// import ResumeCards from '@common/containers/ResumeCards';
import {
  Card,Spin
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
  faSolarPanel,
  faHome,
  faBatteryFull,
} from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AnimatedArrow from '@common/components/AnimatedArrows/AnimatedArrows';
import torre from '@assets/img/markers/torre/torre-electrica.png';
import convertidor from '@assets/img/markers/convertidor/convertidor-ac-dc-blue.png';
import useSystemStatus from './useSystemStatus';
import styles from './SystemStatus.module.less';
import IconInformation from '../IconInformation/IconInformation';
import CenteredContent from '@common/components/ui/CenteredContent';

function SystemStatus({ className }) {

  const { t } = useTranslation();
  const {
    // isModalVisible,
    // setIsModalVisible,
    // showModal,
    // handleOk,
    // handleCancel,
    statusSoc,
    arrowDir,
    arrowSolar,
    arrowGrid,
    arrowLoad,
    solarPower,
    batteryValue,
    socBattery,
    statusBattery,
    loadConsumption,
    powerGrid,
    gridStatus,
    systemStatus,
    mode,
    loading,
  } = useSystemStatus();

  return (
    <>
      {(() => {

          if (loading) {
            return (
              <Card className={className} style={{ height: 'min-content', boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }}>
                <CenteredContent heightContainer="400px">
                  <Spin tip={t('views.device_graphics.loading_data_graphs')} />
                </CenteredContent>
              </Card>
            );
          }

          return (<>
              <Card className={className} style={{ height: 'min-content', boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }}>
                <div className={styles.title}>
                  <p className="device-view-font-size">
                    <b>
                      {t('views.device_graphics.system_status.system_status')}
                      {' '}
                      {systemStatus}
                    </b>
                  </p>
                  <p className="device-view-font-size">
                    <b>
                      {/*t('views.device_graphics.system_status.mode')*/}
                      {' '}
                      {/* {t('devices.secondCard.Mode')} */}
                      {/*mode*/}
                    </b>
                  </p>
                </div>
                <div className={styles.wrapper}>
                  <div className={styles.solar}>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Solar details"
                      infoData={`${solarPower}kW`}
                      labelData="Solar"
                      icon={faSolarPanel}
                      isIcon
                    />
                  </div>
                  <div className={styles.downArrow}>
                    <AnimatedArrow directions={arrowSolar} />
                  </div>
                  <div className={styles.battery}>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Battery details"
                      infoData={`SOC: ${socBattery}%`}
                      labelData={`Status: ${statusBattery} ${batteryValue} kW`}
                      icon={statusSoc || faBatteryFull}
                      isIcon
                    />
                  </div>
                  <div className={styles.leftArrow}>
                    <AnimatedArrow directions={arrowDir} />
                  </div>
                  <div className={styles.inverter}>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Inverter"
                      src={convertidor}
                      alt="Convertidor electrico"
                      infoData=""
                      labelData=""
                      isIcon={false}
                    />
                  </div>
                  <div className={styles.rightArrow}>
                    <AnimatedArrow directions={arrowLoad} />
                  </div>
                  <div className={styles.load}>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Home details"
                      infoData={`${loadConsumption}kW`}
                      labelData="Consumo"
                      icon={faHome}
                      isIcon
                    />
                  </div>
                  <div className={styles.upArrow}>
                    <AnimatedArrow directions={arrowGrid} />
                  </div>
                  <div className={styles.power}>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Energy imported"
                      src={torre}
                      alt="torre electrica"
                      infoData={`${Math.abs(powerGrid)}kW`}
                      labelData={gridStatus}
                      isIcon={false}
                    />
                  </div>
                </div>
              </Card>
          </>);
       })()}
    </>
  );

}

SystemStatus.propTypes = {
  className: PropTypes.string,
};

SystemStatus.defaultProps = {
  className: null,
};

export default SystemStatus;
